export default __webpack_public_path__ + "static/trustpilot-d736a9926496679b526b9946639f8ca5.svg";